// extracted by mini-css-extract-plugin
export default {"root":"Header_root__t7Jkj","FSlogo":"Header_FSlogo__1FybK","logo":"Header_logo__bsRGm","text":"Header_text__M3LH3"};